<template>
  <div class="footer">
    <router-link
      class="menu-item"
      tag="div"
      v-for="(item, i) in menuList"
      :to="item.url"
      :key="i">
      <span>{{item.title}}</span>
      <van-icon class="item-icon" name="arrow" />
    </router-link>
    <div class="app-info">
      <div class="info-item">
        <div>
          <img v-if="$store.state.isMiniApp" class="qr-code" src="https://resource.rcclchina.com.cn/logo/MB/QRCode-1.jpg" />
          <img v-else class="qr-code" src="https://resource.rcclchina.com.cn/logo/MB/QRCode-2.jpg" />
          <p class="item-title">微信公众号</p>
          <p class="item-info">rcclchina2013</p>
        </div>
      </div>
      <div class="info-item weibo" v-show="!$store.state.isMiniApp">
        <div @click="handleBtnClick('https://weibo.com/rcclchina')">
          <img class="icon_weibo" src="../assets/icon_weibo.png" alt="">
          <p class="item-title">新浪微博</p>
          <p class="item-info">皇家加勒比国际邮轮</p>
        </div>
      </div>
    </div>
    <div class="service-tel">
      <p>大陆地区客服热线 <a href="tel:400-820-3187">400-820-3187</a></p>
      <p>服务时间：周一至周五 09:00-18:00(周末和节假日除外)</p>
      <!-- <a href="tel:400-820-3187">
        <span class="label">客服热线</span>
        <span>400-820-3187</span>
      </a> -->
    </div>
    <div class="contact">
      <div class="btn-item" @click="handleContactClick('https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221')">联系我们</div>
      <div class="btn-item" @click="handleUserAgreement('https://mobile.rcclchina.com.cn/wz_index_law/index')">用户协议</div>
      <div class="btn-item" @click="handlePolicyClick('https://mobile.rcclchina.com.cn/wz_index_law_privacy/index')">隐私政策</div>
    </div>
  </div>
</template>

<script>
import { footerMenu as menuList } from '@/utils/dict'
import { mapState } from 'vuex'
export default {
  name: 'BaseFooter',

  data () {
    return {
      menuList
    }
  },
  computed: {
    ...mapState(['isMiniApp'])
  },
  methods: {
    handleBtnClick (href) {
      window.location.href = href
    },
    async handleContactClick (href) {
      // https://mobile.rcclchina.com.cn/contactUsMobile
      if (this.isMiniApp) {
        window.open('https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221', 'newwindow')
      } else {
        window.location.href = href
      }
    },
    async handleUserAgreement (href) {
      if (this.isMiniApp) {
        window.wx.miniProgram.navigateTo({ url: '/pages/userAgreement/userAgreement' })
      } else {
        window.location.href = href
      }
    },
    async handlePolicyClick (href) {
      if (this.isMiniApp) {
        window.wx.miniProgram.navigateTo({ url: '/pages/privacyPolicy/privacyPolicy' })
      } else {
        window.location.href = href
      }
    }
  }
}
</script>

<style lang="less" scoped>
.border-bottom {
  border-bottom: 1px solid #1c3055;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer {
  background-color: #021942;
  .menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 90px;
    padding: 0 46px 0 50px;
    .border-bottom;
    font-size: 28px;
    color: #fff;
    &:active {
      background-color: #1c3055;
    }
  }
  .app-info {
    display: flex;
    align-items: center;
    justify-content: center;
    .border-bottom;
    .info-item {
      flex: none;
      .flex;
      width: 50%;
      height: 350px;
      text-align: center;
      &.weibo {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 0;
          z-index: 1;
          width: 1px;
          height: 250px;
          margin-top: -125px;
          background-color: #0f254c;
        }
      }
      .qr-code {
        display: block;
        width: 145px;
      }
      .icon_weibo {
        display: block;
        width: 157px;
        margin: 0 auto 28px;
      }
      .item-title {
        margin-top: 16px;
        font-size: 18px;
        color: @extra-color;
        line-height: 28px;
      }
      .item-info {
        font-size: 18px;
        color: #fff;
        line-height: 28px;
      }
    }
  }
  .service-tel {
    // .flex;
    color: #fff;
    text-align: center;
    // height: 170px;
    padding: 20px;
    .border-bottom;
    font-size: 24px;
    a {
      color: #fff;
    }
    p {
      margin-bottom: 10px;
    }
    span {
      color: #fff;
    }
    .label {
      margin-right: 16px;
      color: @extra-color;
    }
  }
  .contact {
    .flex;
    height: 122px;
    .btn-item {
      margin: 0 36px;
      font-size: 24px;
      color: #fff;
    }
  }
}
</style>
